
(function () {
  var OMNISEND_BTN_ID = 'omnisend-form-6a35943833843eae466e6d5e-teaser-btn';

  function getOmnisendBtn() {
    return document.getElementById(OMNISEND_BTN_ID)
      || document.querySelector('[id^="omnisend-form-"][id$="-teaser-btn"]');
  }

  function triggerOmnisendNotify() {
    var omnisendBtn = getOmnisendBtn();
    if (omnisendBtn) {
      omnisendBtn.click();
      return true;
    }
    return false;
  }

  function handleNotifyClick(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (triggerOmnisendNotify()) return;

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (triggerOmnisendNotify() || attempts >= 20) {
        clearInterval(interval);
      }
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.klaviyo-bis-trigger, .pdp--notify-wrapper .notify_me_btn');
    if (trigger) {
      handleNotifyClick(e);
    }
  }, true);
})();